import * as types from "../actions/actionsTypes";

let initialState = {
  brands: [],
  types: []
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SEARCH_FILTERS:
      return {
        ...state,
        brands: action.data.brands,
        types: action.data.types,
      };
    case types.RESET_SEARCH_FILTERS:
      return initialState;
    default:
      return state;
  }
};

export default searchReducer;
